<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">Api Test</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field v-model="url" label="URL" placeholder=" "></v-text-field>
	            </v-flex>

                <v-flex xs12 sm12 md12 form-item>
	               <v-textarea row="10" v-model="Form.apiData" label="Payload" placeholder=" "></v-textarea>
	            </v-flex>

                <v-flex xs12 sm12 md12 form-item>
	               <v-select
                       :items="['get', 'post']"
                       v-model="Form.apiType"
                       label="Method"
                   ></v-select>
	            </v-flex>

                <v-flex xs12 sm12 md12 form-item>
	               <v-checkbox label="Token Applicable" v-model="Form.isToken"></v-checkbox>
	            </v-flex>

                <v-flex xs12 sm12 md12 form-item>
	               <v-btn color="primary" @click="fn_sendRequest">Send Request</v-btn>
	            </v-flex>

                <v-flex xs12 sm12 md12 form-item v-if="responseData">
	               <v-textarea row="10" v-model="responseData" label="Reponse Data" placeholder=" "></v-textarea>
	            </v-flex>
				
			</v-layout>
		</v-form>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				Form:{"apiData":null, "apiType":"get", "isToken":false},
                url:null,
                responseData:null
			}
		},
		methods:{

			fn_sendRequest: function(){
				let self = this;
                this.responseData = null;
                this.showLoading("Please wait...");
                let dataObj = JSON.parse(JSON.stringify(this.Form));
                // dataObj.apiData = JSON.parse(dataObj.apiData);
                console.log(JSON.stringify(dataObj));
	            this.getFilterData('TestAPI', this.url, dataObj,
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.responseData = response;
	                        self.hideLoading();
	                    }, 
	                    onError: function(error){
                            self.responseData = null;
	                    	self.hideLoading();
	                    	self.showToast("Something went wrong.");
	                        console.log(error);
	                    }
	                }
	            );
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
	}

</script>


// WEBPACK FOOTER //
// src/components/settings/apitest.vue